<div class="row">
  @if (portEntry.origin === 'HINTERLAND') {
    <div class="col-md-6">
      <app-form-group>
        <label for="planningHinterland">Planning based on</label>
        <app-select id="planningHinterland" [(ngModel)]="portEntry.baseForPlanning" [options]="baseForPlanningOptions"
          [disabled]="!firstBerthVisit" [formatter]="baseForPlanningFormatter" required>
        </app-select>
      </app-form-group>
    </div>
  }
  @if (portEntry.origin === 'SEA') {
    <div class="col-md-6">
      <app-form-group>
        @if (!context.isVlissingenOrTerneuzenWithPilots()) {
          <label for="intention">Intention</label>
        } @else {
          <app-info class="formGroupLabel">
            <label for="intention">Intention</label>
            <div class="tooltipContent">
              <span class="tooltipContent text-start">
                Note: The local movement regulation of North Sea Port can be applied via;
                <ul>
                  <li>ETA:
                    <ul>
                      <li>Intention - Request for entry</li>
                      <li>Planning based on - Pilot boarding place</li>
                      <li>"ETA PBP equal to ETA sea buoy"</li>
                    </ul>
                  </li>
                  <li>GTA:
                    <ul>
                      <li>Intention - Request for entry</li>
                      <li>Planning based on - First berth</li>
                      <li>"ETA First berth"</li>
                    </ul>
                  </li>
                  <li>GTO:
                    <ul>
                      <li>Intention - Request for entry</li>
                      <li>Planning based on - Pilot boarding place</li>
                      <li>"ETA PBP later then ETA sea buoy"</li>
                    </ul>
                  </li>
                  <li>BTV:
                    <ul>
                      <li>Intention - Waiting for orders</li>
                    </ul>
                  </li>
                </ul>
              </span>
            </div>
          </app-info>
        }
        <app-select id="intention" [(ngModel)]="portEntry.intention" [options]="intentionsOptions"
          [disabled]="(this.portEntry.intention === 'REQUEST_FOR_ENTRY') && (context.visit.visitDeclaration.portVisit.firstMovement.order || (!!this.context.visit.incomingTidalWindowStatus && this.context.visit.incomingTidalWindowStatus.tidalWindows.length > 0))" (ngModelChange)="resolveIntention()"
          [formatter]="intentionsFormatter" required placeholder="– Signal intention –">
        </app-select>
      </app-form-group>
    </div>
  }
  <div class="col-md-6">
    @if (portEntry.origin === 'SEA' && portEntry.intention === 'REQUEST_FOR_ENTRY') {
      <app-form-group>
        <label for="etaLocation">Planning based on</label>
        <app-select id="etaLocation" [(ngModel)]="portEntry.baseForPlanning" [options]="baseForPlanningOptions"
          [disabled]="planningBasedOnDisabled()"
          (ngModelChange)="resolveBaseForPlanning($event)" [formatter]="baseForPlanningFormatter" required>
        </app-select>
      </app-form-group>
    }
  </div>
</div>
<div class="row">
  <div class="col-md-6">
    <app-port-passage-planning-area></app-port-passage-planning-area>
    <app-pilot-boarding-place></app-pilot-boarding-place>
    @if (portEntry.origin === 'SEA') {
      <app-form-group>
        <label for="etaSeabuoy">ETA sea buoy</label>
        <app-date-field [(ngModel)]="portEntry.etaSeaBuoy" required id="etaSeabuoy"></app-date-field>
      </app-form-group>
    }
    @if (pilotOnBoard) {
      <app-form-group class="formGroupLabel">
        <label>Pilot on board</label>
        <app-date-field [(ngModel)]="pilotOnBoard" [disabled]="true"></app-date-field>
      </app-form-group>
    }
    <app-eta-eu-entry [(etaFirstEntryEu)]="context.visit.visitDeclaration.etaFirstEntryEu"></app-eta-eu-entry>
    <app-earliest-time-port-entry></app-earliest-time-port-entry>
  </div>
  <div class="col-md-6">
    <app-entry-point></app-entry-point>
    <app-arrival-voyage [voyage]="context.visit.visitDeclaration.arrivalVoyage"></app-arrival-voyage>
  </div>
</div>
